import Exam from '../../../client/models/exam'

export default class Category {
  readonly id: number
  readonly name: String
  readonly description: String
  readonly children: Category[]
  readonly isRoot: boolean
  readonly hasChildren: boolean
  readonly subtreeIds: number[]
  readonly parentIsRoot: boolean
  readonly examsCount: number
  readonly score: number

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.name = data.name
    this.children = []
    this.subtreeIds = data.subtreeIds
    this.isRoot = data.isRoot
    this.hasChildren = data.hasChildren
    this.parentIsRoot = data.parentIsRoot
    this.examsCount = data.examsCount
    this.score = data.score

    if (data.children) {
      data.children.forEach(childrenItem => {
        this.children.push(new Category(childrenItem))
      })
    }
  }

  find(id: number) {
    if (this.id === id) {
      return this
    }

    for (let index = 0; index < this.children.length; index++) {
      const element = this.children[index].find(id)
      if (element) {
        return element
      }
    }

    return null
  }

  getExams(exams: Exam[]): Exam[] {
    return exams.filter((exam) => this.hasExam(exam))
  }

  hasExam(exam: Exam): boolean {
    return this.subtreeIds.some((id) => exam.listIds.indexOf(id) >= 0)
  }
}
